const cronStatus = {
  failure: 'failure', completed: 'completed',
};
const superAdmin = 'Super Admin';

const redisKeyPrefix = {
  future: 'future',
  expired: 'expired',
};

module.exports = { cronStatus, superAdmin, redisKeyPrefix };
